import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/scroll";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Admin from "@/pages/Admin";
import PlatformApp from "@/pages/platform/PlatformApp";
import PlatformResetPassword from "@/pages/platform/PlatformResetPassword";
import OfferteAccept from "@/pages/platform/OfferteAccept";
import SignPage from "@/pages/platform/SignPage";
import PortalPage from "@/pages/platform/PortalPage";
import PaymentReturn from "@/pages/platform/PaymentReturn";
import QuoteAccept from "@/pages/platform/QuoteAccept";
import LegalPage from "@/pages/LegalPage";
import { Preloader } from "@/components/landing/Preloader";
import { Navigation } from "@/components/landing/Navigation";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Manifesto } from "@/components/landing/Manifesto";
import { Services } from "@/components/landing/Services";
import { Process } from "@/components/landing/Process";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import ConsultancyPage from "@/pages/ConsultancyPage";
import LogoConceptsPage from "@/pages/LogoConceptsPage";

function Landing() {
    const [loading, setLoading] = useState(true);
    const started = !loading;

    useEffect(() => initLenis(), []);

    return (
        <LanguageProvider>
            <div
                data-testid="app-root"
                className="relative min-h-screen overflow-x-clip bg-ink font-sans text-bone"
            >
                <div className="noise-overlay" aria-hidden="true" />
                <AnimatePresence>
                    {loading && <Preloader onComplete={() => setLoading(false)} />}
                </AnimatePresence>
                <Navigation started={started} />
                <main>
                    <Hero started={started} />
                    <Marquee />
                    <Manifesto />
                    <Services />
                    <Process />
                    <Contact />
                </main>
                <Footer />
                <Toaster theme="dark" position="bottom-center" />
            </div>
        </LanguageProvider>
    );
}

const isPlatformHost = window.location.hostname.startsWith("app.");

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={isPlatformHost ? <PlatformApp /> : <Landing />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/platform" element={<PlatformApp />} />
                <Route path="/platform/reset-wachtwoord" element={<PlatformResetPassword />} />
                <Route path="/offerte/:token" element={<OfferteAccept />} />
                <Route path="/tekenen/:token" element={<SignPage />} />
                <Route path="/portal/:token" element={<PortalPage />} />
                <Route path="/platform/betaling" element={<PaymentReturn />} />
                <Route path="/aanbod/:token" element={<QuoteAccept />} />
                <Route path="/privacy" element={<LegalPage type="privacy" />} />
                <Route path="/verwerkersovereenkomst" element={<LegalPage type="dpa" />} />
                <Route path="/consultancy" element={<ConsultancyPage />} />
                <Route path="/logo-concepten" element={<LogoConceptsPage />} />
            </Routes>
        </BrowserRouter>
    );
}
